import { ModalCustom } from '$src/components/Modal';
import PropTypes from 'prop-types';

import './index.less';

export default function PauseDialog({ showModal, handlePause, handleCancel, ...rest }) {
  return (
    <ModalCustom
      {...rest}
      title="Pause Virtual Security Guard"
      data-testid="pause-vsg"
      contentTitle="Pause Virtual Security Guard?"
      width="650px"
      contentMessage="When the service is paused, guards will not monitor motion events on your enrolled cameras when you arm your system to Home or Away. You can reenable the service at any time."
      visible={showModal}
      handleOk={handlePause}
      okText="Pause"
      cancelText="Cancel"
    />
  );
}

PauseDialog.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handlePause: PropTypes.func,
  handleCancel: PropTypes.func,
};
